// extracted by mini-css-extract-plugin
module.exports = {"widgetErrorContainer":"WidgetInitializationError_widgetErrorContainer__v_8Vx"};